export default __webpack_public_path__ + "static/media/pin3.715aa091.svg";